var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HgShortTripSearch',{attrs:{"allowHotjarRecord":"","is-mobile":_vm.isMobile,"destinations":_vm.orderedDestinations,"search-url":_vm.searchUrl},on:{"onUpdateDestinationTerm":_vm.updateDestinationTerm,"onUpdateSearchParameters":_vm.updateSearchParameters,"onTriggerSearch":_vm.triggerSearch}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }